(function () {
  var TITLE_SELECTOR = '.product-information__grid--aliexpress .product-details h1';

  function makeToggleButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-title-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Show full title');
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    return btn;
  }

  // Cuts fullText down (binary search on character count) until title + "…" + the
  // toggle button all fit within maxHeight, so the button lands right after the
  // ellipsis on the visible last line instead of overflowing onto a 3rd line.
  function renderTruncated(title, btn, fullText, maxHeight) {
    var lo = 0;
    var hi = fullText.length;
    var best = 0;

    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      title.textContent = fullText.slice(0, mid) + '…';
      title.appendChild(btn);
      if (title.scrollHeight <= maxHeight + 1) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }

    title.textContent = fullText.slice(0, best) + '…';
    title.appendChild(btn);
  }

  function setup(title) {
    if (title.getAttribute('data-ae-title-toggle-init') === 'true') return;
    title.setAttribute('data-ae-title-toggle-init', 'true');

    // Wait a frame so the CSS -webkit-line-clamp: 2 fallback has settled.
    requestAnimationFrame(function () {
      if (title.scrollHeight <= title.clientHeight + 1) return; // fits in 2 lines already

      var fullText = title.textContent.trim();
      var maxHeight = title.clientHeight; // the clamped 2-line height, before JS touches anything

      title.classList.add('product-title--js');
      title.style.maxHeight = maxHeight + 'px';

      var btn = makeToggleButton();
      var expanded = false;

      renderTruncated(title, btn, fullText, maxHeight);

      btn.addEventListener('click', function () {
        expanded = !expanded;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.setAttribute('aria-label', expanded ? 'Show less' : 'Show full title');

        if (expanded) {
          title.classList.add('product-title--expanded');
          title.textContent = fullText;
          title.appendChild(btn);
        } else {
          title.classList.remove('product-title--expanded');
          renderTruncated(title, btn, fullText, maxHeight);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(TITLE_SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
